<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row >
		<b-col class="message-wrapper">
			<b-row>
				<b-col>
					<wysiwyg v-model="message.value"/>
				</b-col>
			</b-row>
			<div class="d-flex pt-2">
				<div class="message-wrapper__request-more-info flex-grow-1">Request More Information / Leave a Message</div>
				<div><b-button variant="primary" class="mb-3" @click="onSend">Send Message <b-spinner small label="Loading..." class="ml-2" v-if="busy"></b-spinner></b-button></div>
			</div>
			<b-row  v-if="value.length > 0">
				<b-col>
					<div class="messsage-wrapper__transcript" v-html="getTranscriptTitle"></div>
				</b-col>
			</b-row>
			<b-row  v-if="value"  v-for=" (m, mindex) in value" :key="'mindex'+mindex" :class="visibleClasses(mindex)">
				<b-col>
					<div :class="messageClasses(mindex)">
					<b-row>
					<b-col class="message__name"><span v-if="m.sourceTable == 'lcr_change_message'  && m.sourceTable != sourceTable">Changes requested from </span> {{m.firstName}} {{m.lastName}}, {{m.organizationName}}<span v-if="m.sourceTable == 'contravention_message' && m.sourceTable != sourceTable">&nbsp;(<router-link :to="'/lane-closure-request/'+laneClosureRequestId+'/view-contravention/'+m.sourceId">Violation #{{m.sourceId}}</router-link>)</span></b-col>
					</b-row>
					<div v-if="m.replyToId.value != null" class="message__replyto">{{getReplyToMessage(m.replyToId.value)}}</div>
					<div class="message__message" v-html="m.message.value"></div>
					<b-row>
					<b-col class="message__date text-right">{{moment(m.messageDateTime.value).format('MMMM D, Y H:mm:ss')}}</b-col>
					</b-row>

					</div>
				</b-col>
			</b-row>
			<b-row v-if="value.length > 3 && readingAll == false" class="pt-3">
				<b-col class="text-center">
					<b-button type="button" variant="light-blue"  @click="onReadAll">Read Remaining {{value.length-3}} Messages</b-button>
				</b-col>
			</b-row>

		</b-col>
	</b-row>
</template>

<script>
import BootstrapField from '../utility/BootstrapField';

export default {
	name: 'MessageChat',
	props: ['value', 'sourceId', 'sourceTable', 'busy'],
	data() {
		return {
			message: new BootstrapField({
				value:""
			}),
			replyToId: new BootstrapField({
			}),
			readingAll: false
		}
	},
	mounted() {
   },
   watch: {
   },
	computed: {
		getTranscriptTitle() {
			let title = "Transcript";
			if (this.sourceTable =="contravention_message") {
				if (this.sourceId) {
					title = "Transcript - Violation #" + this.sourceId;
				} else {
					title = "Transcript - Violation";
				}
			}
			return title
		},
	},
	methods: {
		visibleClasses(index) {
			let classes = "message-entry-wrapper";
			if (index > 3) {
				classes += " message-hidden";
			}
			if (this.readingAll) {
				classes += " reading-all-messages";
			}
			return classes;
		},
		messageClasses(index) {
			let classes = "message";
			if (this.value[index].sourceTable == 'lcr_change_message') {
				classes += " lcr-change-message";
			}
			if (this.value[index].userId == this.$store.getters.userId()) {
				classes += " self";
			}
			return classes;
		},
		getReplyToMessage(id) {
			return null;
		},
		onReadAll() {
			this.readingAll = true;

		},
		onSend() {
			let that = this;
			if (this.message.value.trim() != "" && this.message.value != null) {
				this.$bus.$emit("message:newMessage", {
					message:this.message.value,
					replyToId: this.replyToId.value,
					sourceId: this.sourceId,
					sourceTable: this.sourceTable,
					done: () => {
						that.message.value = "";
						this.message.value = "";
					}
				});
				// done doesn't seem to work...
				this.message.value = "";
			}
		}
	}
}
</script>
